<template>
  <v-container fluid>
    <v-row>
      <v-col lg="6" cols="12">
        <v-card>
          <v-card-title>Happiness</v-card-title>
          <apexchart
            height="150"
            :options="baseChartOptions"
            :series="[getSeries('happiness', 'Happiness', 'area', 30)]"
          ></apexchart>
        </v-card>
      </v-col>
      <v-col lg="2" cols="6">
        <v-card>
          <v-card-title>Past Week</v-card-title>
          <v-card-text
            :class="{
              'red--text text--darken': averageMetrics.happiness.lastWeek <= 2,
              'green--text text--darken': averageMetrics.happiness.lastWeek >= 4
            }"
          >
            <p class="display-3">
              {{ averageMetrics.happiness.lastWeek }}
              <v-icon
                v-if="
                  averageMetrics.happiness.lastWeek >=
                    averageMetrics.happiness.lastMonth
                "
                color="green"
                >mdi-arrow-up</v-icon
              >
              <v-icon v-else color="red">mdi-arrow-down</v-icon>
            </p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="2" cols="6">
        <v-card>
          <v-card-title>Past Month</v-card-title>
          <v-card-text
            :class="{
              'red--text text--darken': averageMetrics.happiness.lastMonth <= 2,
              'green--text text--darken':
                averageMetrics.happiness.lastMonth >= 4
            }"
          >
            <p class="display-3">{{ averageMetrics.happiness.lastMonth }}</p>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="2" cols="6">
        <v-card>
          <v-card-title>Average</v-card-title>
          <v-card-text
            :class="{
              'red--text text--darken': averageMetrics.happiness.total <= 2,
              'green--text text--darken': averageMetrics.happiness.total >= 4
            }"
          >
            <p class="display-3">{{ averageMetrics.happiness.total }}</p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        v-for="metric in $store.getters.moodMetrics"
        :key="metric.name"
        lg="3"
        cols="12"
      >
        <v-card>
          <v-card-text class="pt-1 pb-0">
            <v-row>
              <v-col cols="6" class="py-0">
                <p class="title mb-0">{{ metric.helpText }}</p>
                <p class="display-1 mb-0">
                  <span
                    :class="{
                      'red--text text--darken':
                        averageMetrics[metric.name].lastWeek <= 2,
                      'green--text text--darken':
                        averageMetrics[metric.name].lastWeek >= 4
                    }"
                  >
                    {{ averageMetrics[metric.name].lastWeek }}
                  </span>
                  <v-icon
                    v-if="
                      averageMetrics[metric.name].lastWeek >=
                        averageMetrics[metric.name].lastMonth
                    "
                    color="green"
                    >mdi-arrow-up</v-icon
                  >
                  <v-icon v-else color="red">mdi-arrow-down</v-icon>
                </p>
              </v-col>
              <v-col cols="6" class="py-0">
                <p class="body-1 mb-0">
                  Average:
                  <span
                    :class="{
                      'red--text text--darken':
                        averageMetrics[metric.name].total <= 2,
                      'green--text text--darken':
                        averageMetrics[metric.name].total >= 4
                    }"
                  >
                    {{ averageMetrics[metric.name].total }}</span
                  >
                </p>
                <p class="body-1 mb-0">
                  Past Month:
                  <span
                    :class="{
                      'red--text text--darken':
                        averageMetrics[metric.name].lastMonth <= 2,
                      'green--text text--darken':
                        averageMetrics[metric.name].lastMonth >= 4
                    }"
                  >
                    {{ averageMetrics[metric.name].lastMonth }}
                  </span>
                </p>
              </v-col>
            </v-row>
          </v-card-text>
          <apexchart
            height="100"
            :options="{
              ...metricsChartOptions,
              colors: [getColor(metric.color)]
            }"
            :series="[getSeries(metric.name, metric.helpText, 'area', 7)]"
          ></apexchart>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import axios from "axios";
import moment from "moment";
import VueApexCharts from 'vue-apexcharts'
import colors from 'vuetify/lib/util/colors'

import { mapState } from 'vuex'



export default {
  name: "MoodReports",

  components: {
    apexchart: VueApexCharts,
  },

  data: function () {
    return {
      baseChartOptions: {
        chart: {
          fontFamily: 'Roboto, sans-serif',
          animations: {
            enabled: false,
          },
          sparkline: {
            enabled: true,
          }
        },
        xaxis: {
        },
        yaxis: {
          min: 1,
          max: 5,
          show: false,
        },
        markers: {
          size: 0,
        },
        colors: [colors.green.base, colors.blue.base, colors.red.base],
        dataLabels: {
          enabled: true,
          offsetX: 4,
          offsetY: -6,
          textAnchor: "end"
        },
        grid: {
          padding: {
            top: 20,
            right: 15,
            bottom: 5,
            left: 10
          },
        },
        APIError: false,
        loadingRecords: false,
      }
    }
  },

  mounted() {
    if (this.moodDiaryRecords.length == 0) {
      this.getRecords()
    }
  },

  computed: {
    ...mapState([
      'moodDiaryRecords'
    ]),
    metricsChartOptions: function () {
      const options = {
        ...this.baseChartOptions,

      }
      return options
    },
    moodMetricsToDisplay: function () {
      const conditions = this.$store.state.moodConditions.map(condition => condition.name)
      const ratings = this.$store.state.moodRatings.map(rating => rating.name)
      return conditions.concat(ratings).concat(["happiness"])
    },
    metricsGroupedByDate: function () {
      let metricsGroupedByDate = {
        lastWeek: {},
        lastMonth: {},
        total: {}
      }
      this.moodMetricsToDisplay.forEach(metric => {
        metricsGroupedByDate.lastWeek[metric] = []
        metricsGroupedByDate.lastMonth[metric] = []
        metricsGroupedByDate.total[metric] = []
      })
      let daysPastFromLastWeek = 7
      const lastMoodDiaryRecord = this.moodDiaryRecords[0]
      if (moment(lastMoodDiaryRecord.date).date() !== moment().date()) {
        daysPastFromLastWeek += 1
      }
      const startOfLastWeek = moment().subtract(daysPastFromLastWeek, 'days')
      const startOfLastMonth = moment().subtract(30, 'days')
      this.moodDiaryRecords.forEach(moodDiaryRecord => {
        const recordDate = moment(moodDiaryRecord.date)
        this.moodMetricsToDisplay.forEach(metric => {
          if (recordDate >= startOfLastWeek) {
            metricsGroupedByDate.lastWeek[metric].push(moodDiaryRecord[metric])
          }
          if (recordDate >= startOfLastMonth) {
            metricsGroupedByDate.lastMonth[metric].push(moodDiaryRecord[metric])
          }
          metricsGroupedByDate.total[metric].push(moodDiaryRecord[metric])
        })
      })
      return metricsGroupedByDate
    },
    averageMetrics: function () {
      let averageMetrics = {}
      this.moodMetricsToDisplay.forEach(metric => {
        averageMetrics[metric] = {
          lastWeek: this.getAverage(this.metricsGroupedByDate.lastWeek[metric]),
          lastMonth: this.getAverage(this.metricsGroupedByDate.lastMonth[metric]),
          total: this.getAverage(this.metricsGroupedByDate.total[metric]),
        }
      })
      return averageMetrics
    }
  },

  methods: {
    getRecords: function () {
      this.loadingRecords = true
      this.APIError = false
      axios
        .get(
          `${process.env.VUE_APP_API_ROOT_URL}mood/records/`,
          this.$store.getters.axiosConfig
        )
        .then(response => {
          this.$store.commit("updateMoodDiaryRecords", response.data)
          this.loadingRecords = false
        })
        .catch(() => {
          this.APIError = true
          this.loadingRecords = false
        });
    },
    getSeries: function (metricName, label, chartType, numberOfRecords) {
      const data = [...this.moodDiaryRecords].slice(0, numberOfRecords).reverse().map(record => (
        { x: record.date, y: record[metricName] }
      ))
      const series = {
        type: chartType,
        name: label,
        data: data
      }
      return series
    },
    convertKebabToCamelCase: function (str) {
      return str.replace(/-([a-z])/g, function (g) { return g[1].toUpperCase(); })
    },
    getColor: function (colorNames) {
      const color = colorNames.split(" ")[0]
      return colors[this.convertKebabToCamelCase(color)]['base']
    },
    getAverage: function (array) {
      if (array.length === 0) {
        return null
      }

      const average = array.reduce((a, b) => (a + b)) / array.length
      return average.toFixed(1)
    },
  }
}
</script>
